import Component from './form-item.vue';
export default Component;
